var _circle, _circle2, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 39,
    stroke: "#00306E",
    strokeOpacity: 0.08,
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M56.5 58.3334H23.5C22.7483 58.3334 22.125 57.71 22.125 56.9584C22.125 56.2067 22.7483 55.5834 23.5 55.5834H56.5C57.2517 55.5834 57.875 56.2067 57.875 56.9584C57.875 57.71 57.2517 58.3334 56.5 58.3334Z",
    fill: "#3270FC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M52.8701 24.3801C49.3134 20.8234 45.8301 20.7318 42.1817 24.3801L39.9634 26.5984C39.7801 26.7818 39.7067 27.0751 39.7801 27.3318C41.1734 32.1901 45.0601 36.0768 49.9184 37.4701C49.9917 37.4884 50.0651 37.5068 50.1384 37.5068C50.3401 37.5068 50.5234 37.4334 50.6701 37.2868L52.8701 35.0684C54.6851 33.2718 55.5651 31.5301 55.5651 29.7701C55.5834 27.9551 54.7034 26.1951 52.8701 24.3801Z",
    fill: "#3270FC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6185 39.1383C46.0868 38.8817 45.5735 38.625 45.0785 38.3317C44.6752 38.0933 44.2902 37.8367 43.9052 37.5617C43.5935 37.36 43.2268 37.0667 42.8785 36.7733C42.8418 36.755 42.7135 36.645 42.5668 36.4983C41.9618 35.985 41.2835 35.325 40.6785 34.5917C40.6235 34.555 40.5318 34.4267 40.4035 34.2617C40.2202 34.0417 39.9085 33.675 39.6335 33.2533C39.4135 32.9783 39.1568 32.575 38.9185 32.1717C38.6252 31.6767 38.3685 31.1817 38.1118 30.6683C37.8552 30.1183 37.6535 29.5867 37.4702 29.0917L25.9568 40.605C25.7185 40.8433 25.4985 41.3017 25.4435 41.6133L24.4535 48.635C24.2702 49.8817 24.6185 51.055 25.3885 51.8433C26.0485 52.485 26.9652 52.8333 27.9552 52.8333C28.1752 52.8333 28.3952 52.815 28.6152 52.7783L35.6552 51.7883C35.9852 51.7333 36.4435 51.5133 36.6635 51.275L48.1768 39.7617C47.6635 39.5783 47.1685 39.3767 46.6185 39.1383Z",
    fill: "#3270FC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg4);
export default __webpack_public_path__ + "static/media/4.764ccf5aac9dd4cc416de89798d9bc9c.svg";
export { ForwardRef as ReactComponent };